<template>
  <div class="container">
    <div class="logo" @click="skipHome">
      <img :src="require('@/assets/img/login_logo.png')" alt="">
    </div>
    <div class="login">
      <div class="login_check">
        <img v-if="loginType" :src="require('@/assets/icon/wechat_check.png')" @click="checkLogin" alt="">
        <img v-else :src="require('@/assets/icon/mobile_check.png')" @click="checkLogin" alt="">
      </div>
      <div class="login_left"></div>
      <div class="login_right" v-if="loginType">
        <div class="login_title" v-if="loginType"><span>手机号登录</span></div>
        
        <div class="login_phone">
          <img :src="require('@/assets/img/phone_icon.png')" alt="">
          <el-input v-model="fromData.phone" maxlength="11" placeholder="请输入手机号" />
        </div>
        <div class="login_code">
          <img :src="require('@/assets/img/code_icon.png')" alt="">
          <el-input v-model="fromData.code" maxlength="6" placeholder="请输入验证码" />
          <div class="login_code_btn" v-loading="getCodeNumber">
            <span v-if="!isCodeState" @click="getCode">获取验证码</span>
            <span style="cursor: no-drop;" v-else>{{ seconds }}秒</span>
          </div>
        </div>
        <div class="login_btn" @click="login" v-loading="loginState"><span>登录</span></div>
      </div>
      <div class="login_right" v-else>
        <div class="login_title"><span>小程序登录</span></div>
        <div class="qrcode">
          <img :src="qrcodeUrl" alt="" />
          <div>打开微信扫一扫，快速登录/注册</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { codeNumber, loginApi, } from '@/api/login.js'
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getInfo, getLoginPic, getTokenCheck, } from "@/api/home";
export default {
  metaInfo: {
    title: '京递快运官网 - 登录', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '京递快运官网 - 登录'
    },
    {
      name: 'description',
      content: '京递 是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。'
    }
    ],
  },
  name: 'Login',
  data() {
    return {
      phoneNumber: '',
      seconds: 60,
      getCodeNumber: false,
      isCodeState: false,
      loginState: false,
      fromData: {
        phone: '',
        code: '',
      },
      loginType: true,
      qrcodeUrl: "",
      timer: null,
      uuid: null,
    }
  },
  created() {
    // console.log(this.userInfo);
    this.uuid = this.uuid2(16, 16);
    this.getQRcode();
    // if (getToken()) {
    //   this.getInfoData();
    //   // console.log(this.userInfo);
    // } else {
    //   localStorage.removeItem("userInfo");
    //   this.userInfo = null;
    // }

  },
  destroyed(){
    clearInterval(this.timer);
  },
  methods: {
    skipHome() {
      this.$router.replace('/')
    },
    async login() {
      if (this.fromData.phone.length != 11) return this.$message.warning('请输入正确的手机号');
      if (this.fromData.code.length == '') return this.$message.warning('请输入验证码');
      this.loginState = true;
      let loginRes = await loginApi({ phone: this.fromData.phone, code: this.fromData.code });
      if (loginRes.code == 200) {
        setToken(loginRes.token)
        this.getInfoData();
        this.loginState = false;
        this.$message.success('登录成功');
        setTimeout(() => {
          this.$router.replace('/');
        }, 2000)
      } else {
        this.loginState = false;
      }
      // setTimeout(() => {


      // },3000)
    },
    async getCode() {
      if (this.fromData.phone.length != 11) return this.$message.warning('请输入正确的手机号');
      this.getCodeNumber = true;
      let code = await codeNumber(this.fromData.phone);
      console.log(code);
      this.getCodeNumber = false;
      this.isCodeState = true;
      this.$message.success('已发送验证码，请注意查收');
      setInterval(() => {
        if (this.seconds <= 0) {
          this.isCodeState = false;
          this.seconds = 60;
        } else {
          this.seconds = this.seconds - 1;
        }
      }, 1000)
      // setTimeout(() => {
      //   this.getCodeNumber = false;
      //   this.isCodeState = true;
      //   this.$message.success('已发送验证码，请注意查收');
      //   setInterval(() => {
      //     if(this.seconds <= 0){
      //       this.isCodeState = false;
      //       this.seconds = 60;
      //     }else{
      //       this.seconds = this.seconds - 1;
      //     }
      //   },1000)
      // },3000)

      // let code = await codeNumber(this.fromData.phone)
      // this.getCodeNumber = true;

    },
    getInfoData() {
      getInfo({}).then((response) => {
        // console.log(response);
        if (response.code == 200) {
          this.userInfo = response;
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response)
          );
        }
      });
    },
    checkLogin() {
      this.loginType = !this.loginType;
      if (this.loginType === false) {
        this.QRLogin();
      }else{
        clearInterval(this.timer);
      }
    },
    getQRcode() {
      getLoginPic({}, this.uuid).then((response) => {
        let url = URL.createObjectURL(response);
        this.qrcodeUrl = url;
      });
      // this.getTokenData();
    },
    QRLogin() {
      this.uuid = this.uuid2(16, 16);
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getQRcode();
        this.getTokenData();
      });
    },
    getTokenData() {
      this.timer = setInterval(() => {
        getTokenCheck({}, this.uuid).then((response) => {
          if (response.data) {
            this.$message;
            setToken(response.data);
            clearInterval(this.timer);
            this.getInfoData();
            this.$message.success('登录成功');
            setTimeout(() => {
              this.$router.replace('/');
            }, 2000)
          }
        });
      }, 1000);
    },
    uuid2(len, radix) {
      var chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
          ""
        );
      var uuid = [],
        i;
      radix = radix || chars.length;

      if (len) {
        // Compact form
        for (i = 0; i < len; i++)
          uuid[i] = chars[0 | (Math.random() * radix)];
      } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }

      return uuid.join("");
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background: url('../assets/img/login_bg.png') no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .logo {
    width: 301px;
    height: 126px;
    position: absolute;
    top: 37px;
    left: 214px;

    img {
      width: 100%;
      height: 100%;
      user-select: none;
      cursor: pointer;
    }
  }

  .login {
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    display: flex;
    background: #fff;
    position: relative;

    .login_check {
      position: absolute;
      right: 0;
      top: 0;

      img {
        width: 80px;
        height: 80px;
        cursor: pointer;
      }
    }

    .login_left {
      width: 600px;
      height: 600px;
      background: url('../assets/img/login_img.png') no-repeat;
      // background-size: cover;
    }

    .login_right {
      width: 600px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .login_title {
        width: 100%;
        font-size: 32px;
        color: #333;
        font-weight: 500;
        padding: 45px 0 17px 0;
        text-align: center;
        border-bottom: 1px solid rgba($color: #979797, $alpha: .18);
        margin-bottom: 93px;
      }

      .login_phone {
        width: 445px;
        height: 58px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 18px 16px;
        border: 1px solid #C3C3C3;
        border-radius: 7px;
        margin-bottom: 30px;

        ::v-deep .el-input__inner {
          border-color: transparent !important;
          background: transparent !important;
          font-size: 18px;
          color: #999;
          font-weight: 500;
          padding: 0;
        }

        img {
          width: 17px;
          height: 20px;
          margin-right: 20px;
        }
      }

      .login_code {
        width: 445px;
        height: 58px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 18px 16px;
        border: 1px solid #C3C3C3;
        border-radius: 7px;
        margin-bottom: 71px;

        ::v-deep .el-input__inner {
          border-color: transparent !important;
          background: transparent !important;
          font-size: 18px;
          color: #999;
          font-weight: 500;
          padding: 0;
        }

        img {
          width: 17px;
          height: 20px;
          margin-right: 20px;
        }

        .login_code_btn {
          flex-shrink: 0;
          border-left: 1px solid rgba($color: #979797, $alpha: .71);
          padding-left: 18px;
          font-size: 18px;
          color: #ccc;
          cursor: pointer;
          user-select: none;
        }
      }

      .login_btn {
        width: 445px;
        height: 57px;
        margin: 0 auto;
        text-align: center;
        line-height: 57px;
        color: #fff;
        background: #FF8A00;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 600;
        user-select: none;
        cursor: pointer;
      }
    }
  }
}

.qrcode {
  text-align: center;

  img {
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
  }
}
</style>